import React from 'react'
import PlatButton from 'components/presenter/buttons/PlatButton'
import cn from 'classnames'
import { 
  AppBar, 
  Toolbar, 
  IconButton, 
  Popover,
  Fade, 
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListItemIcon,
  Divider,
  Switch
} from '@material-ui/core'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import MenuIcon from '@material-ui/icons/Menu'
import Brightness4Icon from '@material-ui/icons/Brightness4'
import TranslateIcon from '@material-ui/icons/Translate'
import LanguageSelect from 'components/container/nav/LanguageSelect'
import { useThemeMode } from 'components/presenter/theme/themeMode'
import { Trans, useTranslation, Link } from 'gatsby-plugin-react-i18next'
import { useStore, authStoreId, userStoreId } from 'stores'

import * as styles from './header.module.css'

const Header = ({ onMenuClick = () => {}}) => {
  const { t } = useTranslation()
  const authStore = useStore(authStoreId)
  const userStore = useStore(userStoreId)
  const {themeMode, toggleThemeMode} = useThemeMode()

  const [anchorEl, setAnchorEl] = React.useState(null)
  const [userProfile, setUserProfile] = React.useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const logout = async () => {
    handleClose()
    await authStore.actions.logout()
  }

  const handleChangeLanguage = () => {
    handleClose()
  }

  React.useEffect(() => {
    setUserProfile(userStore.getters.getUserProfile())
  }, [userStore.getters.getUserProfile()])
  
  const name = !userProfile ? '' : userProfile.name 
  const url = !userProfile || !userProfile.profile_image ? null : `${userProfile.profile_image.url}-tn`

  return (
    <AppBar position="sticky" className={cn(styles.header)}>
      <Toolbar>
        <IconButton className={styles.menuIcon} edge="start" color="inherit" onClick={onMenuClick}>
          <MenuIcon />
        </IconButton>
        <div className={cn(styles.space)} />
        { userProfile 
          ? <PlatButton
              aria-describedby="popup-menu"
              onClick={handleClick}>
              <div className={styles.profileButton}>
                <Avatar alt={name} src={url} />
                <span className={styles.profileTxt}>{name}</span>
              </div>
            </PlatButton>
          :  <></> }
        <Popover
          id="popup-menu"
          className={styles.popover}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          TransitionComponent={Fade}
        >
          <List component="nav" className={styles.list}>
            <Link className={cn(styles.profileLink)} to="/profile/">
              <ListItem button alignItems="flex-start" onClick={handleClose}>
                <ListItemAvatar>
                  <Avatar alt={name} src={url} />
                </ListItemAvatar>
                <ListItemText
                  primary={name}
                  secondary={t('mainMenu.viewYourProfile')}
                />
              </ListItem>
            </Link>
            <Divider variant="middle" component="li" className={styles.divider} />
            <ListItem className={styles.meunItem}>
              <ListItemIcon>
                <Brightness4Icon className={styles.meunItem} />
              </ListItemIcon>
              <ListItemText primary={t('mainMenu.darkMode')} />
              <Switch
                className='mui-switch'
                checked={themeMode === 'dark'}
                onClick={toggleThemeMode}
                name="darkMode"
                inputProps={{ 'aria-label': 'Dark mode' }}
              />
            </ListItem>
            <ListItem className={styles.meunItem}>
              <ListItemIcon>
                <TranslateIcon className={styles.meunItem} />
              </ListItemIcon>
              <LanguageSelect 
                onChange={handleChangeLanguage} />
            </ListItem>
            <ListItem button onClick={logout} className={styles.meunItem}>
              <ListItemIcon>
                <ExitToAppIcon className={styles.meunItem} />
              </ListItemIcon>
              <ListItemText primary={t('common.loginout')} />
            </ListItem>
            <ListItem className={cn(styles.meunItem, styles.licenseTxt)}>
              <ListItemText primary={
                <Trans
                i18nKey="mainMenu.license"
                components={{
                  term: <Link to='/terms/' onClick={handleClose} />,
                  privacy: <Link to='/privacy/' onClick={handleClose} />,
                  // eslint-disable-next-line jsx-a11y/anchor-has-content
                  contact: <a href = "mailto:kingwu@creatisoft.io" />,
                }}
              /> } />
            </ListItem>
          </List>
        </Popover>
      </Toolbar>
    </AppBar>
  )
}
export default Header